import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { HEADER_HEIGHT } from '~constant/layout';

import GnbItem from '../GnbItem';
import { getMenuCss } from '../helper';
import * as HeaderStyle from '../style';

export const cssModalWrapper = css`
  width: 100%;
  min-width: auto;
  border-radius: 0;
  top: 0;
`;

export const Header = styled(HeaderStyle.Wrapper)`
  position: relative;
`;

export const ButtonClose = styled.a`
  display: flex;
  align-items: center;
  height: ${HEADER_HEIGHT}px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 16px;

  ${({ theme }) => theme.media.tablet} {
    padding: 0 32px;
  }
`;

export const ContentsWrapper = styled.div`
  padding: 16px;

  ${({ theme }) => theme.media.tablet} {
    padding: 16px 32px;
  }
`;

export const TitleMenu = styled.h3`
  padding-left: 8px;
  margin-bottom: 24px;
  ${getFontStyle('bold150_T1')};
`;

export const Menu = styled.div`
  display: grid;
  gap: 32px 0;
  grid-template-columns: 1fr 1fr;
  padding: 0 16px 16px;
`;

export const MenuItem = styled.a<{ gnbId: string }>`
  color: ${({ theme }) => theme.colors.gray800};
  ${getFontStyle('bold150_B1')};

  span {
    position: relative;
    display: inline-block;
    padding-left: 32px;

    &::before {
      content: '';
      position: absolute;
      top: 3px;
      left: 0;
      display: block;
      width: 24px;
      height: 24px;
      background-size: 24px auto;
      background-repeat: no-repeat;
    }

    ${({ gnbId }) => getMenuCss(gnbId)};
  }
`;

export const UnloggedWrapper = styled.div`
  padding-top: 24px;
  margin-bottom: 40px;
`;

export const LoggedWrapper = styled.div`
  padding-top: 24px;
  margin-bottom: 40px;
`;

export const ProfileWrapper = styled.div`
  margin-bottom: 16px;
  text-align: center;
`;

export const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
`;

export const UserName = styled.p`
  color: ${({ theme }) => theme.colors.black100};
  ${getFontStyle('midium150_B1')};

  strong {
    ${getFontStyle('bold150_B1')};
  }
`;

export const LoginMessage = styled.p`
  margin-bottom: 16px;
  text-align: center;
  ${getFontStyle('midium150_B1')};
  color: ${({ theme }) => theme.colors.gray700};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const LoggedGnbWrapper = styled.div`
  display: flex;
  gap: 0 8px;
`;

export const LoggedGnbItem = styled(GnbItem)`
  width: 100%;
  height: 45px;
  position: relative;
  line-height: 45px;
  color: ${({ theme }) => theme.colors.gray800};
  background-color: ${({ theme }) => theme.colors.gray200};
  text-align: center;
  border-radius: 8px;

  span {
    position: relative;
  }

  &.bookmark {
    span {
      top: -3px;
      margin-right: 8px;
    }
  }

  &.mypage {
    span {
      ${({ isNew }) =>
        isNew &&
        css`
          left: -10px;

          &::after {
            content: 'new';
            position: absolute;
            top: 0;
            right: -21px;
            color: ${({ theme }) => theme.colors.magenta500};
            ${getFontStyle('midium120_C2')}
          }
        `}/* } */
    }
  }
`;
